import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { debounce } from 'lodash';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { PartnersService } from 'src/app/api/collaborator/partners.service';
import { AgenciesService } from 'src/app/api/tourism/agencies.service';
import * as _ from 'underscore';
declare var $: any;

@Component({
  selector: 'component-search-partnercompanies',
  templateUrl: './search-partnercompanies.component.html',
  styleUrls: ['./search-partnercompanies.component.css']
})
export class SearchPartnercompaniesComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Output() selectedPartnerEvent = new EventEmitter<string>();
  @Input() classSize: string | null = null;
  @Input() placeholderText: string | null = "Buscar empresa socia";

  data = [];
  keyword = 'fullname_str';
  isTypedSearch = false;
  classSearch: any;

  constructor(private partnerService: PartnersService) {}

  ngOnInit() {
    this.classSearch = this.classSize;
  }

  debouncedSearchInput = debounce(event => this.getSearch(event), 250);

  getSearch(search_: any) {
    this.isTypedSearch = true;
    if (search_.length > 1) {
      let val_params = 'search=' + search_;
      this.partnerService.search(val_params).subscribe({
        next: (data: any) => {
          this.data = data.results;
          this.data.map(
            (item: any) =>
              (item.fullname_str = `${item.document_str} ${item.tradename}`)
          );
        }
      });
    } else {
      this.data = [];
    }
  }

  selectSearch(item: any) {
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
      (<any>$('.autocomplete-container .not-found')).hide();
    }, 10);

    this.selectedPartnerEvent.emit(item);
    this.data = [];
    this.searchInput.clear();
    this.searchInput.focus();
  }

  closedSearchPanel(): void {
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  clearedInputSearch(): void {
    this.searchInput.focus();
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  focused() {
    this.searchInput.focus();
  }
}
